







import {
  defineComponent,
  useContext,
} from '@nuxtjs/composition-api';
// eslint-disable-next-line
import ClientOnly from 'vue-client-only';
import { usePageStore } from '~/stores/page';
import Notification from '~/components/Notification.vue';

export default defineComponent({
  name: 'PageResolver',
  components: {
    Notification,
    ClientOnly,
  },
  middleware: [
    'url-resolver',
  ],
  setup() {
    const { routeData } = usePageStore();
    const componentsMap = {
      CATEGORY:()=>import( '~/modules/catalog/pages/category.vue'),
      CMS_PAGE:()=>import('~/pages/Cms.vue'),
      PRODUCT:()=>import('~/pages/Product/_slug/index.vue'),
      HOT_TOPICS:()=>import('~/pages/solepro/HotTopicsPage.vue'),
      HOT_TOPIC:()=>import('~/pages/solepro/HotTopicPage.vue'),
    }
    const type = componentsMap[routeData?.type]
    return {
      type,
    };
  },

});
